// component
import { Iconify } from "@components";

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <Iconify icon={name} width={22} height={22} />
);

const navConfig = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  {
    title: "Categories",
    path: "/categories",
    icon: getIcon("tabler:category"),
  },
  {
    title: "Users",
    path: "/users",
    icon: getIcon("tabler:users"),
  },
  {
    title: "KYC",
    path: "/kyc",
    icon: getIcon("tabler:shield-check"),
  },
  {
    title: "Products",
    path: "/products",
    icon: getIcon("tabler:list"),
  },
  {
    title: "İlan Ücreti",
    path: "/listing-fees",
    icon: getIcon("tabler:coin"),
  },
  {
    title: "Pages",
    path: "/pages",
    icon: getIcon("tabler:file"),
  },
  {
    title: "Contact",
    path: "/contact",
    icon: getIcon("tabler:message"),
  },
  {
    title: "Logs",
    path: "/logs",
    icon: getIcon("tabler:history"),
  },
];

export default navConfig;
